/**
 * Description the CMS opens an Editorial Workflow pull request or merge request with, which tells a
 * maintainer where it came from.
 */
export const PULL_REQUEST_DESCRIPTION = 'Automatically generated by Sveltia CMS';
